import React from 'react';
import Loader from '../../common/loader';
import FulfilmentOptionGroup from '../../fulfilment/fulfilmentOptionGroup/fulfilmentOptionGroup';
import InfoCard from '../../pdp/info-card/InfoCard';
import { AvailabilityOptions, FulfilmentOptionsProps } from '../utils/types';
import { styles } from './Availability.css';
export interface AvailabilityProps {
  isLoading?: boolean;
  availabilityOptions?: AvailabilityOptions;
  IsLIA?: boolean;
}

const Availability = ({ isLoading, availabilityOptions, IsLIA }: AvailabilityProps): JSX.Element => {
  const optionsOrder = IsLIA ? ['pickUp', 'clickAndCollect', 'delivery'] : ['delivery', 'clickAndCollect', 'pickUp'];
  return (
    <div className={styles.resultContainer}>
      {isLoading ? (
        <Loader message="Loading..." />
      ) : (
        <>
          {availabilityOptions
            ? optionsOrder.map((itemInQueue, index) => {
                const availableOption: FulfilmentOptionsProps = availabilityOptions[itemInQueue];
                const isDelivery = availableOption.title === 'Delivery';
                const isClickAndCollect = availableOption.title === 'Click & Collect';
                return availableOption ? (
                  <div className={styles.cardWrapper} key={`${index}-${itemInQueue}`}>
                    {isDelivery ? (
                      <InfoCard type={availableOption.isAvailable ? 'info' : 'warning'}>
                        <div className={styles.cardContainer}>
                          <FulfilmentOptionGroup
                            title={availableOption.title}
                            isDelivery={isDelivery}
                            available={availableOption.isAvailable}
                            options={availableOption.options}
                          />
                        </div>
                      </InfoCard>
                    ) : isClickAndCollect ? (
                      <InfoCard
                        type={availableOption.isAvailable && availableOption.isWithinRange ? 'info' : 'warning'}
                      >
                        <div className={styles.cardContainer}>
                          <FulfilmentOptionGroup
                            title={availableOption.title}
                            isClickAndCollect={isClickAndCollect}
                            available={availableOption.isAvailable}
                            options={availableOption.options}
                            isWithinRange={availableOption.isWithinRange}
                            maxDistanceWarning={window.Jbhifi?.pdpAlerts?.availabilityMax}
                          />
                        </div>
                      </InfoCard>
                    ) : (
                      <InfoCard
                        type={availableOption.isAvailable && availableOption.isWithinRange ? 'info' : 'warning'}
                      >
                        <div className={styles.cardContainer}>
                          <FulfilmentOptionGroup
                            title={availableOption.title}
                            available={availableOption.isAvailable}
                            options={availableOption.options}
                            isWithinRange={availableOption.isWithinRange}
                            maxDistanceWarning={window.Jbhifi?.pdpAlerts?.availabilityMax}
                          />
                        </div>
                      </InfoCard>
                    )}
                  </div>
                ) : null;
              })
            : null}

          {!availabilityOptions?.delivery?.isAvailable &&
          !availabilityOptions?.clickAndCollect?.isAvailable &&
          !availabilityOptions?.pickUp?.isAvailable ? null : (
            <div className={styles.footer}>
              <p>More options available in checkout</p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Availability;
